// src/pages/StockPage.js
import React, { useState, useEffect } from 'react';
import { stockAPI, menuAPI, yearAPI } from '../api/api';
import { Modal, FormRow, ModalActions } from './ClassesPage';
import toast from 'react-hot-toast';
import './CommonPage.css';


export default function StockPage() {
  const round3 = (n) => Math.round(n * 1000) / 1000;
  const now  = new Date();
  const [year,   setYear]   = useState(now.getFullYear());
  const [month,  setMonth]  = useState(now.getMonth()+1);
  const [stock,  setStock]  = useState([]);
  const [items,  setItems]  = useState([]);
  const [years,  setYears]  = useState([]);
  const [showAdd,setShowAdd]= useState(false);
  const [form,   setForm]   = useState({ item_id:'', opening_stock:'', received_quantity:'', receipt_date:'', receipt_reference:'', minimum_stock:'' });
  const [loading,setLoading]= useState(false);
  const [xlLoading,setXlLoading] = useState(false);
  const KN_M =['','ಜನವರಿ','ಫೆಬ್ರವರಿ','ಮಾರ್ಚ್','ಏಪ್ರಿಲ್','ಮೇ','ಜೂನ್','ಜುಲೈ','ಆಗಸ್ಟ್','ಸೆಪ್ಟೆಂಬರ್','ಅಕ್ಟೋಬರ್','ನವೆಂಬರ್','ಡಿಸೆಂಬರ್'];
  const KN_M_FULL = ['','ಜನವರಿ','ಫೆಬ್ರವರಿ','ಮಾರ್ಚ್','ಏಪ್ರಿಲ್','ಮೇ','ಜೂನ್','ಜುಲೈ','ಆಗಸ್ಟ್','ಸೆಪ್ಟೆಂಬರ್','ಅಕ್ಟೋಬರ್','ನವೆಂಬರ್','ಡಿಸೆಂಬರ್'];
  
const [filterMode, setFilterMode] = useState('monthly'); // 'monthly'|'range'|'annual'
const [fromDate,   setFromDate]   = useState('');
const [toDate,     setToDate]     = useState('');
const [selItemId,  setSelItemId]  = useState('');  // '' = all items
const [selAyId,    setSelAyId]    = useState('');
const [openingMap, setOpeningMap] = useState({}); 

  const load = () => { stockAPI.get(year,month).then(r=>setStock(r.data.data||[])).catch(()=>{}); };

  // loadAll() function ನಂತರ add — previous month closing fetch:
const loadPrevClosing = async () => {
  try {
    const token = localStorage.getItem('token');
    const prevMonth = month === 1 ? 12 : month - 1;
    const prevYear  = month === 1 ? year - 1 : year;
    const res = await fetch(
      `/api/grain-stock?year=${prevYear}&month=${prevMonth}`,
      { headers: { Authorization: `Bearer ${token}` }}
    );
    const d = await res.json();
    const map = {};
    (d.data || []).forEach(s => {
      const op   = parseFloat(s.opening_stock   || 0);
      const recv = parseFloat(s.received_quantity|| 0);
      const used = parseFloat(s.consumed_quantity|| 0);
      map[s.item_id] = Math.max(0, op + recv - used);
    });
    setOpeningMap(map);
  } catch {}
};

  useEffect(() => {
    load();
    menuAPI.list().then(r=>setItems(r.data.data||[])).catch(()=>{});
    yearAPI.list().then(r=>setYears(r.data.data||[])).catch(()=>{});
    loadPrevClosing();
  }, []); // eslint-disable-line

  useEffect(() => { load();loadPrevClosing(); }, [year, month]); // eslint-disable-line

  const save = async () => {
  if (!form.item_id) { toast.error('ಆಹಾರ ಪದಾರ್ಥ ಆಯ್ಕೆ ಮಾಡಿ'); return; }
  const received = parseFloat(form.received_quantity) || 0;
  if (received > 0 && !form.receipt_date) {
    toast.error('ಸ್ವೀಕೃತ ಪ್ರಮಾಣ ಇದ್ದರೆ PDS ದಿನಾಂಕ ಅಗತ್ಯ');
    return;
  }
    setLoading(true);
    try {
      const ay = years.find(y=>y.is_current);
      await stockAPI.save({ ...form, stock_year:year, stock_month:month, academic_year_id: ay?.id||1, opening_stock:parseFloat(form.opening_stock)||0, received_quantity:parseFloat(form.received_quantity)||0, minimum_stock:parseFloat(form.minimum_stock)||0 });
      toast.success('ಸ್ಟಾಕ್ ಉಳಿಸಲಾಗಿದೆ ✅'); setShowAdd(false); load();
    } catch(e) { toast.error(e.response?.data?.message||'ತಪ್ಪಾಗಿದೆ'); }
    finally { setLoading(false); }
  };

  // ── Excel Download ────────────────────────────────────────
  // downloadExcel function REPLACE:
const downloadExcel = async () => {
  setXlLoading(true);
  try {
    const token = localStorage.getItem('token');

    // Build query params based on filter mode
    let params = '';
    if (filterMode === 'monthly') {
      params = `year=${year}&month=${month}`;
    } else if (filterMode === 'range' && fromDate && toDate) {
      params = `from_date=${fromDate}&to_date=${toDate}`;
    } else if (filterMode === 'annual' && selAyId) {
      params = `academic_year_id=${selAyId}`;
    } else {
      toast.error('ಫಿಲ್ಟರ್ ಆಯ್ಕೆ ಮಾಡಿ'); setXlLoading(false); return;
    }
    if (selItemId) params += `&item_id=${selItemId}`;

    const res = await fetch(`/api/grain-stock/excel?${params}`,
      { headers: { Authorization: `Bearer ${token}` } });
    if (!res.ok) throw new Error();
    const blob = await res.blob();
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = `Stock_Report.xlsx`;
    a.click();
    URL.revokeObjectURL(a.href);
    toast.success('Excel download ✅');
  } catch { toast.error('Excel download ತಪ್ಪಾಗಿದೆ'); }
  finally { setXlLoading(false); }
};
  return (
    <div className="common-page">
      <div className="page-header">
        <h1 className="page-title">🌾 ಧಾನ್ಯ ಸ್ಟಾಕ್ ನಿರ್ವಹಣೆ</h1>
        <p className="page-desc">ತಿಂಗಳ ಆರಂಭ, ಸ್ವೀಕೃತ, ಬಳಸಿದ ಮತ್ತು ಶಿಲ್ಕು ಸ್ಟಾಕ್</p>
      </div>
      <div className="att-controls" style={{background:'rgba(255,255,255,0.04)',border:'1px solid rgba(255,255,255,0.08)',borderRadius:'16px',padding:'1.2rem',display:'flex',flexWrap:'wrap',gap:'1rem',marginBottom:'1.5rem'}}>
        <div className="control-group">
          <label className="ctrl-label">ವರ್ಷ</label>
          <select className="ctrl-input" value={year} onChange={e=>setYear(e.target.value)}>
            {[2024,2025,2026].map(y=><option key={y} value={y}>{y}</option>)}
          </select>
        </div>
        <div className="control-group">
          <label className="ctrl-label">ತಿಂಗಳು</label>
          <select className="ctrl-input" value={month} onChange={e=>setMonth(e.target.value)}>
            {KN_M.slice(1).map((m,i)=><option key={i+1} value={i+1}>{m}</option>)}
          </select>
        </div>
        <button className="act-btn act-green" style={{alignSelf:'flex-end'}} onClick={() => {
  setForm({
    item_id:'', opening_stock:'', received_quantity:'',
    receipt_date:'', receipt_reference:'', minimum_stock:''
  });
  setShowAdd(true);
}}>+ ಸ್ಟಾಕ್ ನಮೂದಿಸಿ</button>
        
        {/* Excel controls — existing buttons ನಂತರ add */}
<div style={{ background:'rgba(255,255,255,0.03)', border:'1px solid rgba(255,255,255,0.08)',
  borderRadius:12, padding:'12px 14px', marginBottom:16 }}>
  <div style={{ fontSize:11, color:'#9ca3af', marginBottom:10, fontWeight:600 }}>
    📊 Excel ವರದಿ ಫಿಲ್ಟರ್
  </div>

  {/* Filter mode tabs */}
  <div style={{ display:'flex', gap:8, marginBottom:12, flexWrap:'wrap' }}>
    {[['monthly','📅 ತಿಂಗಳ'],['range','📆 ದಿನಾಂಕ'],['annual','🎓 ವರ್ಷ']].map(([k,l])=>(
      <button key={k} onClick={()=>setFilterMode(k)} style={{
        padding:'5px 14px', borderRadius:8, fontSize:12, cursor:'pointer',
        border: filterMode===k ? '1px solid rgba(74,222,128,0.5)' : '1px solid rgba(255,255,255,0.12)',
        background: filterMode===k ? 'rgba(74,222,128,0.12)' : 'transparent',
        color: filterMode===k ? '#4ade80' : '#9ca3af',
      }}>{l}</button>
    ))}
  </div>

  {/* Range filter */}
  {filterMode === 'range' && (
    <div style={{ display:'flex', gap:10, flexWrap:'wrap', marginBottom:10 }}>
      <div>
        <div style={{ fontSize:10, color:'#6b7280', marginBottom:3 }}>ಪ್ರಾರಂಭ</div>
        <input type="date" className="ctrl-input" value={fromDate}
          onChange={e=>setFromDate(e.target.value)} />
      </div>
      <div>
        <div style={{ fontSize:10, color:'#6b7280', marginBottom:3 }}>ಅಂತ್ಯ</div>
        <input type="date" className="ctrl-input" value={toDate}
          onChange={e=>setToDate(e.target.value)} />
      </div>
    </div>
  )}

  {/* Annual filter */}
  {filterMode === 'annual' && (
    <div style={{ marginBottom:10 }}>
      <select className="ctrl-input" value={selAyId}
        onChange={e=>setSelAyId(e.target.value)}>
        <option value="">— ಶೈಕ್ಷಣಿಕ ವರ್ಷ ಆಯ್ಕೆ —</option>
        {years.map(y=><option key={y.id} value={y.id}>
          {y.year_label}{y.is_current?' ✅':''}
        </option>)}
      </select>
    </div>
  )}

  {/* Item filter — all modes ನಲ್ಲಿ */}
  <div style={{ display:'flex', gap:10, alignItems:'center', flexWrap:'wrap' }}>
    <div>
      <div style={{ fontSize:10, color:'#6b7280', marginBottom:3 }}>ಆಹಾರ ಪದಾರ್ಥ</div>
      <select className="ctrl-input" value={selItemId}
        onChange={e=>setSelItemId(e.target.value)}>
        <option value="">ಎಲ್ಲಾ Items</option>
        {items.map(i=><option key={i.id} value={i.id}>{i.name_kannada}</option>)}
      </select>
    </div>
    <button className="act-btn act-green"
      style={{ alignSelf:'flex-end', opacity:xlLoading?0.6:1 }}
      onClick={downloadExcel} disabled={xlLoading}>
      {xlLoading ? '⏳...' : '📥 Excel Download'}
    </button>
  </div>
</div>
      </div>
      <p style={{color:'#aaa',fontSize:'0.8rem',marginBottom:'0.5rem'}}>
        ಸೂತ್ರ: ಕೊನೆಯ ಶಿಲ್ಕು = ಆರಂಭದ ಶಿಲ್ಕು + ಸ್ವೀಕೃತ - ಬಳಸಿದ್ದು
      </p>

      <div className="config-table-wrap">
        <table className="config-table">
          <thead>
            <tr>
              <th>ಆಹಾರ ಪದಾರ್ಥ</th>
              <th>ಆರಂಭ (Opening)</th>
              <th>ಸೇರಿಸಿದ (+)</th>
              <th>ಬಳಕೆ (-)</th>
              <th>ಬಾಕಿ (Remaining)</th>
              <th>ಸ್ಥಿತಿ</th>
            </tr>
          </thead>
          <tbody>
            {stock.length === 0 && (
              <tr><td colSpan={6} style={{textAlign:'center',padding:'2rem',color:'rgba(255,255,255,0.3)',fontFamily:'Noto Sans Kannada'}}>ಈ ತಿಂಗಳು ಸ್ಟಾಕ್ ಮಾಹಿತಿ ಇಲ್ಲ</td></tr>
            )}
            {stock.map(s=>{
              const opening = parseFloat(s.opening_stock||0);
              const added   = parseFloat(s.received_quantity||0);
              const used    = parseFloat(s.consumed_quantity||0);
              const closing = opening + added - used;
              const minStock = parseFloat(s.minimum_stock||0);
              const low = closing <= 0 || (minStock>0 && closing<minStock);
              return (
                <tr key={s.id}>
                  <td>{s.item_name_kannada}</td>
                  <td>{opening.toFixed(2)}</td>
                  <td style={{color:'#4ade80'}}>+ {added.toFixed(2)}</td>
                  <td style={{color:'#f87171'}}>- {used.toFixed(2)}</td>
                  <td>
                    <strong style={{color: closing <= 0 ? '#f87171' : '#4ade80'}}>
                      {closing.toFixed(2)}
                    </strong>
                  </td>
                  <td>
                    <span style={{fontSize:'0.72rem',padding:'0.2rem 0.6rem',borderRadius:'8px',background:low?'rgba(248,113,113,0.15)':'rgba(74,222,128,0.12)',color:low?'#fca5a5':'#86efac'}}>
                      {closing <= 0 ? '❌ ಮುಗಿದಿದೆ' : low ? '⚠️ ಕಡಿಮೆ' : '✅ ಸರಿ'}
                    </span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {showAdd && (
        <Modal title="ಧಾನ್ಯ ಸ್ಟಾಕ್ ನಮೂದಿಸಿ" onClose={()=>setShowAdd(false)}>
          <FormRow label="ಆಹಾರ ಪದಾರ್ಥ">
            <select className="modal-input" value={form.item_id} onChange={e => {
  const iid = e.target.value;
  const autoOpening = openingMap[iid];
  // ಈ month ನಲ್ಲಿ ಈಗಾಗಲೇ stock entry ಇದ್ದರೆ existing value use ಮಾಡಿ
  const existing = stock.find(s => String(s.item_id) === String(iid));
  setForm(p => ({
    ...p,
    item_id: iid,
    opening_stock: existing
      ? String(parseFloat(existing.opening_stock || 0))
      : autoOpening !== undefined
      ? String(round3(autoOpening))
      : '',
    received_quantity: existing
      ? String(parseFloat(existing.received_quantity || 0))
      : '',
    receipt_date: existing?.receipt_date
      ? new Date(existing.receipt_date).toISOString().slice(0,10)
      : '',
    receipt_reference: existing?.receipt_reference || '',
    minimum_stock: existing
      ? String(parseFloat(existing.minimum_stock || 0))
      : '',
  }));
}}>
              <option value="">ಆಯ್ಕೆ ಮಾಡಿ</option>
              {items.map(i => (<option key={i.id} value={i.id}>{i.name_kannada}</option>))}
            </select>
          </FormRow>
          <FormRow label="ಆರಂಭದ ಶಿಲ್ಕು (ಕೆಜಿ/ಲೀ/ಸ೦ಖ್ಯೆ)">
  <div style={{ position:'relative' }}>
    <input className="modal-input" type="number" step="0.001"
      placeholder="0.000" value={form.opening_stock}
      onChange={e=>setForm(p=>({...p,opening_stock:e.target.value}))}
      style={{ paddingRight: form.item_id && openingMap[form.item_id] !== undefined ? '110px' : undefined }}
    />
    {form.item_id && openingMap[form.item_id] !== undefined && (
      <span style={{
        position:'absolute', right:10, top:'50%', transform:'translateY(-50%)',
        fontSize:11, color:'#4ade80', fontWeight:600, pointerEvents:'none',
        fontFamily:'Noto Sans Kannada',
      }}>
        ← ಹಿಂದಿನ ಬಾಕಿ: {round3(openingMap[form.item_id])}
      </span>
    )}
  </div>
  {form.item_id && openingMap[form.item_id] !== undefined && (
    <div style={{ fontSize:11, color:'#6b7280', marginTop:4, fontFamily:'Noto Sans Kannada' }}>
      ✅ ಹಿಂದಿನ ತಿಂಗಳ ಕೊನೆ ಬಾಕಿಯಿಂದ auto-fill ಆಗಿದೆ — ಬೇಕಾದರೆ ಬದಲಾಯಿಸಬಹುದು
    </div>
  )}
</FormRow>
          <FormRow label="ಸ್ವೀಕೃತ ಪ್ರಮಾಣ (ಕೆಜಿ/ಲೀ/ಸಂಖ್ಯೆ)">
            <input className="modal-input" type="number" step="0.001" placeholder="0.000" value={form.received_quantity} onChange={e=>setForm(p=>({...p,received_quantity:e.target.value}))} />
          </FormRow>
          <FormRow label="PDS ರಸೀದಿ ದಿನಾಂಕ">
            <input className="modal-input" type="date" value={form.receipt_date} max={new Date().toISOString().split('T')[0]} onChange={e=>setForm(p=>({...p,receipt_date:e.target.value}))} />
          </FormRow>
          <FormRow label="ರಸೀದಿ ಸಂಖ್ಯೆ">
            <input className="modal-input" placeholder="PDS/2024/001" value={form.receipt_reference} onChange={e=>setForm(p=>({...p,receipt_reference:e.target.value}))} />
          </FormRow>
          <FormRow label="ಕನಿಷ್ಠ ಸ್ಟಾಕ್ ಎಚ್ಚರಿಕೆ ಮಿತಿ (ಕೆಜಿ/ಸಂಖ್ಯೆ)">
            <input className="modal-input" type="number" step="0.1" placeholder="20" value={form.minimum_stock} onChange={e=>setForm(p=>({...p,minimum_stock:e.target.value}))} />
          </FormRow>
          <ModalActions loading={loading} onSave={save} onCancel={()=>setShowAdd(false)} />
        </Modal>
      )}
      <style>{`.ctrl-label{font-family:'Noto Sans Kannada',sans-serif;font-size:.78rem;font-weight:600;color:rgba(255,255,255,.6);display:block;margin-bottom:.3rem}.ctrl-input{background:rgba(255,255,255,.07);border:1.5px solid rgba(255,255,255,.12);border-radius:10px;color:#fff;padding:.6rem .9rem;font-family:'Noto Sans Kannada',sans-serif;font-size:.88rem;outline:none}.ctrl-input option{background:#0a1628}.control-group{display:flex;flex-direction:column;gap:.3rem}
      `}</style>
    </div>
  );
}